import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const HomeIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 16 17"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M15.0961 7.10766 8.84609 1.21078c-.00305-.00266-.00592-.00554-.00859-.00859-.23011-.209274-.52998-.325237-.84102-.325237-.31103 0-.6109.115963-.84101.325237l-.00859.00859L.903906 7.10766c-.127345.1171-.228997.25935-.298522.41777-.069525.15842-.10541.32954-.105384.50254v7.22263c0 .3315.131696.6495.366116.8839.234424.2344.552364.3661.883884.3661H5.5c.33152 0 .64946-.1317.88388-.3661.23442-.2344.36612-.5524.36612-.8839v-3.75h2.5v3.75c0 .3315.1317.6495.36612.8839.23442.2344.55238.3661.88388.3661h3.75c.3315 0 .6495-.1317.8839-.3661.2344-.2344.3661-.5524.3661-.8839V8.02797c0-.173-.0359-.34412-.1054-.50254-.0695-.15842-.1712-.30067-.2985-.41777ZM14.25 15.2506H10.5v-3.75c0-.3315-.1317-.6494-.3661-.8839-.23444-.2344-.55238-.3661-.8839-.3661h-2.5c-.33152 0-.64946.1317-.88388.3661-.23442.2345-.36612.5524-.36612.8839v3.75H1.75V8.02797l.00859-.00781L8 2.12562l6.2422 5.89297.0086.00782-.0008 7.22419Z"
      stroke="none"
    />
  </SvgIcon>
);

export default HomeIcon;
